import { memo, useState } from 'react'
import { Button } from '@cargomart/ui'
import { devFeatures } from 'utils/feature'

interface FeatureFlag {
  name: string
  label: string
  description?: string
}

const FEATURE_FLAGS: FeatureFlag[] = [
  {
    name: 'devFeatures',
    label: 'Dev Features',
    description: 'Инструменты для разработчиков и тестировщиков'
  },
  {
    name: 'orderYarcheGuestCreate',
    label: 'Order Yarche Guest',
    description: 'Оформление посылки для неавторизованного пользователя'
  },
  {
    name: 'orderYarcheCreate',
    label: 'Order Yarche',
    description: 'Оформление посылки для авторизованного пользователя'
  }
]

export const FeatureFlagsPanel = memo(() => {
  const [isOpen, setIsOpen] = useState(false)
  const [flags, setFlags] = useState<Record<string, boolean>>(() => {
    const initial: Record<string, boolean> = {}
    FEATURE_FLAGS.forEach((flag) => {
      initial[flag.name] = localStorage.getItem(flag.name) === 'true'
    })
    return initial
  })

  if (!devFeatures) {
    return null
  }

  const toggleFlag = (flagName: string) => {
    const newValue = !flags[flagName]
    localStorage.setItem(flagName, String(newValue))
    setFlags((prev) => ({ ...prev, [flagName]: newValue }))
    // Reload page to apply changes
    window.location.reload()
  }

  const togglePanel = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <div className="fixed right-4 top-4 z-[9999]">
      <Button onClick={togglePanel} size="sm" variant="outline">
        🚩 Feature Flags
      </Button>

      {isOpen && (
        <div className="shadow-lg absolute right-0 top-12 w-80 rounded-md border border-outline bg-surface p-4">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-on-surface">Feature Flags</h3>
            <button
              className="text-on-surface/60 hover:text-on-surface"
              onClick={togglePanel}
              type="button"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <div className="space-y-3">
            {FEATURE_FLAGS.map((flag) => (
              <div key={flag.name} className="flex items-start gap-3">
                <input
                  checked={flags[flag.name]}
                  className="mt-1 h-4 w-4 cursor-pointer"
                  id={flag.name}
                  onChange={() => toggleFlag(flag.name)}
                  type="checkbox"
                />
                <label className="flex-1 cursor-pointer select-none" htmlFor={flag.name}>
                  <div className="text-sm font-medium text-on-surface">{flag.label}</div>
                  {flag.description && <div className="text-xs text-on-surface/60">{flag.description}</div>}
                </label>
              </div>
            ))}
          </div>

          <div className="text-xs text-on-surface/60 mt-4 border-t border-outline pt-3">
            Изменения применятся после перезагрузки страницы
          </div>
        </div>
      )}
    </div>
  )
})

FeatureFlagsPanel.displayName = 'FeatureFlagsPanel'
